import { render, staticRenderFns } from "./CameraAndCtrl.vue?vue&type=template&id=e588fd44&scoped=true&"
import script from "./CameraAndCtrl.vue?vue&type=script&lang=js&"
export * from "./CameraAndCtrl.vue?vue&type=script&lang=js&"
import style0 from "./CameraAndCtrl.vue?vue&type=style&index=0&id=e588fd44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e588fd44",
  null
  
)

export default component.exports